import { render, staticRenderFns } from "./UploadInvoice.vue?vue&type=template&id=3810dc1f&scoped=true"
import script from "./UploadInvoice.vue?vue&type=script&lang=ts"
export * from "./UploadInvoice.vue?vue&type=script&lang=ts"
import style0 from "./UploadInvoice.vue?vue&type=style&index=0&id=3810dc1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3810dc1f",
  null
  
)

export default component.exports